import { SimpleModalId } from 'constants/modalId';
import { ResetRenderModalContentContainer } from './ResetRenderModalContentContainer';
import { makeGuardedModal } from 'components/guardedModal/makeGuardedModal';

export const ResetRenderModal = makeGuardedModal(SimpleModalId.ResetRender, ResetRenderModalContentContainer);
